var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.tag-plus-icon-st0{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tag-plus-icon-st0",
    d: "M3.33129 11.3264V9.32762H3.99755V11.3264H5.99633V11.9927H3.99755V13.9914H3.33129V11.9927H1.33252V11.3264H3.33129ZM1.34139 8.00397L0 6.66258V1.33226C0 0.59126 0.596473 0 1.33226 0H6.66259L15.5777 8.91514C16.0995 9.43692 16.1021 10.2817 15.5827 10.8011L10.8011 15.5827C10.2824 16.1014 9.43731 16.0999 8.91514 15.5777L7.31997 13.9826C7.74745 13.3113 7.9951 12.5143 7.9951 11.6595C7.9951 9.26775 6.05619 7.32884 3.66442 7.32884C2.80962 7.32884 2.01266 7.5765 1.34139 8.00397ZM3.66442 4.66381C4.21637 4.66381 4.66381 4.21637 4.66381 3.66442C4.66381 3.11247 4.21637 2.66503 3.66442 2.66503C3.11248 2.66503 2.66503 3.11247 2.66503 3.66442C2.66503 4.21637 3.11248 4.66381 3.66442 4.66381ZM3.66442 15.3239C5.68823 15.3239 7.32884 13.6833 7.32884 11.6595C7.32884 9.63572 5.68823 7.9951 3.66442 7.9951C1.64062 7.9951 0 9.63572 0 11.6595C0 13.6833 1.64062 15.3239 3.66442 15.3239Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPlusIcon);
export default __webpack_public_path__ + "static/media/tag-plus-icon.b4dda5264da168573104f964c5134731.svg";
export { ForwardRef as ReactComponent };